import { RefreshButton } from '@/components/core';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui-kit/select';
import { TEMPLATE_CATEGORIES } from '@/modules/templates/constants/template-categories';
import { useTranslation } from 'react-i18next';
import { PUBLIC_TEMPLATES_QUERY_KEY, type PublicTemplatesController } from './use-public-templates';
import { TemplatesSearchInput } from './templates-search-input';

interface PublicTemplatesToolbarProps {
  controller: PublicTemplatesController;
}

/** Search + category filter + refresh for the Public Templates tab (sits in the tab row). */
export function PublicTemplatesToolbar({ controller }: PublicTemplatesToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <TemplatesSearchInput
        value={controller.searchInput}
        onChange={controller.onSearchChange}
        placeholder={t('ORGTEMPLATES_PUBLIC_SEARCH_PLACEHOLDER')}
      />
      <Select
        value={controller.category ?? 'all'}
        onValueChange={(value) => controller.onCategoryChange(value === 'all' ? null : value)}
      >
        <SelectTrigger className="h-9 w-full sm:w-56">
          <SelectValue placeholder={t('ORGTEMPLATES_ALLCATEGORIES')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('ORGTEMPLATES_ALLCATEGORIES')}</SelectItem>
          {TEMPLATE_CATEGORIES.map((cat) => (
            <SelectItem key={cat.slug} value={cat.slug}>
              {cat.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <RefreshButton className="md:hidden" queryKey={PUBLIC_TEMPLATES_QUERY_KEY} />
    </div>
  );
}
